var render, staticRenderFns
import script from "./CustomTransition.vue?vue&type=script&lang=js&"
export * from "./CustomTransition.vue?vue&type=script&lang=js&"
import style0 from "./CustomTransition.vue?vue&type=style&index=0&id=5be4b00c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4b00c",
  null
  
)

export default component.exports